import FUNCTION_API_BASE from "../functions";

export default {
  async getFilesList(context) {
    const response = await fetch(`${FUNCTION_API_BASE}SdkList`, {
      method: 'GET',
      headers: { "Authorization": `Bearer ${context.rootGetters.accessToken}` }
    })

    const responseData = await response.json();

    context.commit('setStatus', {
      status: responseData.Status
    });

    context.commit('setFilesList', {
      fileList: responseData.SdksList
    })
  },
  async sendFileLink(context, payload) {
    const response = await fetch(`${FUNCTION_API_BASE}SdkSend`, {
      method: 'POST',
      headers: { "Authorization": `Bearer ${context.rootGetters.accessToken}` },
      body: JSON.stringify(payload.fileName != null ? {
        FileName: payload.fileName
      } : { FileDes: payload.fileDes })
    });

    const responseData = await response.json();

    context.commit('setFileLinkStatus', {
      mailStatus: responseData.Status,
      respFileName: responseData.FileName
    });
  }
}